var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaJtdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.971,
    height: 90.026,
    viewBox: "0 0 78.971 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minerva_jtd_icon",
    transform: "translate(-1234 -8993.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139139",
    "data-name": "\\uD328\\uC2A4 139139",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(1246.238 8998.198)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139140",
    "data-name": "\\uD328\\uC2A4 139140",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(1242.008 8993.967)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139141",
    "data-name": "\\uD328\\uC2A4 139141",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(1243.827 8995.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139142",
    "data-name": "\\uD328\\uC2A4 139142",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(1242.008 9012.164)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139143",
    "data-name": "\\uD328\\uC2A4 139143",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(1242.008 9014.367)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139144",
    "data-name": "\\uD328\\uC2A4 139144",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(1285.383 8993.967)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139145",
    "data-name": "\\uD328\\uC2A4 139145",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(1234 9000.314)",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139150",
    "data-name": "\\uD328\\uC2A4 139150",
    d: "M28.331,4.1H2.048a2.049,2.049,0,0,1,0-4.1H28.331a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(1250.512 9025.295)",
    fill: "#e8566f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139151",
    "data-name": "\\uD328\\uC2A4 139151",
    d: "M47.786,4.1H2.048a2.048,2.048,0,1,1,0-4.1H47.786a2.048,2.048,0,1,1,0,4.1Z",
    transform: "translate(1250.512 9038.131)",
    fill: "#b7022d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139152",
    "data-name": "\\uD328\\uC2A4 139152",
    d: "M28.331,4.1H2.048a2.049,2.049,0,0,1,0-4.1H28.331a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(1250.512 9050.966)",
    fill: "#e8566f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139153",
    "data-name": "\\uD328\\uC2A4 139153",
    d: "M47.786,4.1H2.048a2.049,2.049,0,0,1,0-4.1H47.786a2.049,2.049,0,1,1,0,4.1Z",
    transform: "translate(1250.512 9063.801)",
    fill: "#b7022d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139403",
    "data-name": "\\uD328\\uC2A4 139403",
    d: "M25.005,17.623a2.827,2.827,0,0,1-.971,2.273,4.062,4.062,0,0,1-2.714.827,11.668,11.668,0,0,1-2.267-.22V18.67h.193a4.8,4.8,0,0,0,1.605.351,2.741,2.741,0,0,0,1.058-.176,1.2,1.2,0,0,0,.62-.568,4.431,4.431,0,0,0,.2-1.695v-4.74H20.417V10.189h4.588ZM35.46,11.911h-3.41v8.66H29.776v-8.66h-3.41V10.189H35.46Zm1.491,8.66V10.189H40.2a8.449,8.449,0,0,1,3.438.565A4.358,4.358,0,0,1,45.58,12.49a5.485,5.485,0,0,1,.713,2.9,5.381,5.381,0,0,1-.741,2.807,4.4,4.4,0,0,1-1.981,1.808,8.2,8.2,0,0,1-3.348.565Zm2.273-8.749v7.117h1.116q3.576,0,3.576-3.569,0-3.548-3.576-3.548Z",
    transform: "translate(1223.947 8992.975)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaJtdIcon);
export default __webpack_public_path__ + "static/media/minerva_jtd_icon.1abdbb65cb7a7190b65bfb4c1e6144d4.svg";
export { ForwardRef as ReactComponent };